import { RESET_SETUP, SET_SETUP, SET_COUPON_IMAGES, SET_BANNER_IMAGES } from "../Types/SetupTypes";

const initialState = {
  setupDetails: [],
  images: [],
  bannerImages: [],
};

const SetupReducer = (state = initialState, action) => {
  if (action.type === SET_SETUP) {
    return { ...state, setupDetails: action.payLoad };
  } else if (action.type === RESET_SETUP) {
    return { ...state, setupDetails: [] };
  } else if (action.type === SET_COUPON_IMAGES) {
    return { ...state, images: action.payLoad };
  } else if (action.type === SET_BANNER_IMAGES) {
    return { ...state, bannerImages: action.payLoad };
  } else {
    return state;
  }
};

export default SetupReducer;
